if(!customElements.get("faq-block")) {
  customElements.define("faq-block", class FaqBlock extends HTMLElement {
    constructor() {
      super();

      this.question = this.querySelector(".faq-block__question");
      this.question.addEventListener("click", this.answerToggle.bind(this));
    }

    answerToggle() {
      this.question.classList.toggle("question-open");
    }
  })
}
